import * as jsxRuntime from "/builds/dti-gab/logistica/plataforma-ativos-avalia-gab/front-backoffice-ativos-avalia-gab/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment